import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hmd-page__hd"
}
const _hoisted_2 = {
  key: 1,
  class: "hmd-page_bd"
}
const _hoisted_3 = {
  key: 2,
  class: "hmd-page__bd"
}
const _hoisted_4 = {
  key: 3,
  class: "hmd-page__ft"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'hmd-page': true, 'has-header': _ctx.hasHeaderSlot, 'has-footer': _ctx.hasFooterSlot }, "ub ub-ver ub-f1"]),
    style: _normalizeStyle({ 'padding-bottom': _ctx.hasFooterSlot ? _ctx.paddingBottom + 'px' : '0px' })
  }, [
    (_ctx.hasHeaderSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header")
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasBodySlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "body")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])),
    (_ctx.hasFooterSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 6))
}